import React, { Component } from "react";
import { Redirect, withRouter } from "react-router";
import { Helmet } from "react-helmet";

import GlobalContext from "./globalContext";

// import { post, get, patch } from "../framework/api";
import cache, { cacheItems } from "../framework/cache";

import axios from "axios";
import config from "../configuration/config";
import { Snackbar, withTheme } from "@material-ui/core";

import CancelIcon from "@material-ui/icons/Cancel";
// import theme from '../framework/theme'
// import s from './snackbar.css'

import { isIOS } from "react-device-detect";
import { CheckBox } from "@material-ui/icons";
import moment from "moment";

import label from "../framework/whiteLabel";
import _ from "lodash";

class GlobalProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      shoppingCart: null,
      previousShoppingCartItems: null,
      groupCategories: null,
      orders: null,
      searchResults: null,
      attributes: [],
      selectedItemViewCategory: null,
      reorderItems: null,

      errorSnackbarText: "",
      errorSnackbarState: false,

      successSnackbarText: "",
      successSnackbarState: false,

      timeNotification: false,

      searchBarTextValue: "",
      groupItemsLoading: false,
      searchItemsLoading: false,

      dashboardpageYOffset: 0,
      searchResultPromiseCount: 0,
      scrollPositionSet: true,

      dashboard: null,
      newCartCreated: false,

      bottomNavigationValue: "homeDialogState",
      appMenuDialogState: false,
      accountDialogState: false,
      favoritesDialogState: false,
      itemViewDialogState: false,
      ordersDialogState: false,
      shoppingCartDialogState: false,
      chooseSavingsDialogState: false,
      oldShoppingCartDialogState: false,
      reorderDialogState: false,
      popUpLocationInstanceDialogState: false,
      tutorialDialogState: false,
      newUserDeliveryLocationDialog: false,

      dashboardHistory: [],

      popUpLocationInstanceDialogCallout: -350,

      modifyShoppingCartPromiseCount: 0,

      deviceCheck: false,
      controlledCartItem: false,
      covidDialog: true,

      whiteLabelData: null
    };
  }

  async componentWillMount() {
    let staleWhiteLabelData = cache.getItem(cacheItems.WHITE_LABEL_THEME);
    let newWhiteLabelData = await this.getWhiteLabelData();

    if (
      staleWhiteLabelData &&
      isEquivalent(staleWhiteLabelData, newWhiteLabelData)
    ) {
      this.setState({ whiteLabelData: true });
    } else if (newWhiteLabelData) {
      cache.setItem(cacheItems.WHITE_LABEL_THEME, newWhiteLabelData);
      window.location.reload();
    } else {
      this.setState({ whiteLabelData: true });
    }
  }

  componentDidMount() {
    setInterval(this.checkShoppingTimeLeft.bind(this), 300000);
    if (cache.getItem(cacheItems.USER_UUID)) {
      this.getUserByUuid();
    }
    const img = new Image();
    img.src =
      "https://ff-attribute-icons.s3.us-east-2.amazonaws.com/FF_Tutorial.gif";
  }

  //INTERNAL FUNCTIONS
  setGlobalState = (key, value) => {
    this.setState({ [key]: value });
  };

  setAllDialogsToFalse = () => {
    this.setState({
      bottomNavigationValue: "homeDialogState",
      appMenuDialogState: false,
      accountDialogState: false,
      favoritesDialogState: false,
      itemViewDialogState: false,
      ordersDialogState: false,
      shoppingCartDialogState: false,
      chooseSavingsDialogState: false
    });
  };

  stateHardReset = async (resetUser = false) => {
    if (resetUser) {
      this.setState({ user: null });
    }
    this.setState({
      shoppingCart: null,
      previousShoppingCartItems: null,
      groupCategories: null,
      orders: null,
      searchResults: null,
      attributes: [],
      selectedItemViewCategory: null,
      reorderItems: null,

      errorSnackbarText: "",
      errorSnackbarState: false,

      successSnackbarText: "",
      successSnackbarState: false,

      timeNotification: false,

      searchBarTextValue: "",
      groupItemsLoading: false,
      searchItemsLoading: false,

      dashboardpageYOffset: 0,
      searchResultPromiseCount: 0,
      scrollPositionSet: true,

      dashboard: null,
      newCartCreated: false,

      bottomNavigationValue: "homeDialogState",
      appMenuDialogState: false,
      accountDialogState: false,
      favoritesDialogState: false,
      itemViewDialogState: false,
      ordersDialogState: false,
      shoppingCartDialogState: false,
      chooseSavingsDialogState: false,
      oldShoppingCartDialogState: false,
      reorderDialogState: false,
      tutorialDialogState: false,
      newUserDeliveryLocationDialog: false,

      dashboardHistory: [],

      modifyShoppingCartPromiseCount: 0,

      deviceCheck: false,
      controlledCartItem: false,
      covidDialog: true,

      //DONT ADD THIS BREAKS THE WHITE LABEL
      // whiteLabelData: null
    });
  };

  checkShoppingTimeLeft = async () => {
    const { shoppingCart, timeNotification } = this.state;
    if (shoppingCart) {
      let bufferTimeOfDay = moment.unix(
        shoppingCart.popUpLocationInstance.pickupTimestampStart -
          shoppingCart.popUpLocationInstance.bufferTime
      );
      let checkTime = moment(bufferTimeOfDay).subtract(20, "m");
      let checkMinutesToClose = moment().isAfter(checkTime);
      let checkPULIShoppingClosed = (checkMinutesToClose = moment().isAfter(
        bufferTimeOfDay
      ));
      if (checkPULIShoppingClosed) {
        this.setState({
          errorNeedsRedirect: true,
          errorRedirectRoute: "/find-hot-spot",
          errorSnackbarState: true,
          errorSnackbarText: "This Hotspot shopping time has passed."
        });
      } else {
        if (!timeNotification || (checkMinutesToClose && timeNotification)) {
          let minutesToClose = moment().to(bufferTimeOfDay);
          this.setState({
            timeNotification: true,
            successSnackbarState: true,
            successSnackbarText: `Shopping will close ${minutesToClose} for this hotspot. Your current location is below!`,
            bottomNavigationValue: "popUpLocationInstanceDialogState",
            popUpLocationInstanceDialogState: true,
            popUpLocationInstanceDialogCallout: 50
          });
        }
      }
      // if (user && !user.hideTutorial && !this.state.tutorialDialogState) {
      //   this.handleOpenTutorial();
      // }
    }
  };

  updateDashboardCards = item => {
    if (Math.abs(item.quantityInCartDifference) > 0) {
      let { groupCategories, selectedItemViewCategory } = this.state;
      let selectedItemViewCategoryUuid = null;
      if (selectedItemViewCategory) {
        selectedItemViewCategoryUuid = selectedItemViewCategory.uuid;
      }
      for (let i = 0; i < groupCategories.length; i++) {
        for (let k = 0; k < groupCategories[i].itemCategoryList.length; k++) {
          if (
            groupCategories[i].itemCategoryList[k].inventoryItemCategoryUuid ===
            item.inventoryItemCategoryUuid
          ) {
            this.getItemsInCategory(
              item.inventoryItemCategoryUuid,
              selectedItemViewCategoryUuid === item.inventoryItemCategoryUuid
                ? true
                : false
            ).then(items => {
              let itemsInCart = items.calculatedInventoryItems.filter(
                f => f.isInCart
              );
              if (itemsInCart.length > 0) {
                groupCategories[i].itemCategoryList[k].inCart = true;
              } else {
                groupCategories[i].itemCategoryList[k].inCart = false;
              }
              let favoriesInCart = items.calculatedInventoryItems.filter(
                f => f.isFavorite
              );
              if (favoriesInCart.length > 0) {
                groupCategories[i].itemCategoryList[k].favorited = true;
              } else {
                groupCategories[i].itemCategoryList[k].favorited = false;
              }
            });
          }
        }
      }
      this.setState({ groupCategories });
      return null;
    } else {
      return null;
    }
  };

  getWhiteLabelData = async () => {
    let url = location.host;
    try {
      let whiteLabelData = await this.apiGet({
        path: `/whiteLabel/${url}`,
        // body:
        auth: false
      });
      // cache.setItem(cacheItems.WHITE_LABEL_THEME, whiteLabelData)
      return whiteLabelData;
    } catch (err) {
      throw err;
    }
  };

  handleDashboardActions = (direction, dialogState) => {
    let { dashboardHistory } = this.state;
    if (direction === "FORWARD") {
      this.props.history.push("/dashboard");
      dashboardHistory.push(dialogState);
      this.setState({ [dialogState]: true, dashboardHistory });
    }
    if (direction === "BACK") {
      if (dashboardHistory.length === 0) {
        return null;
      }
      this.setState({ [dashboardHistory.pop()]: false });
      this.setState({
        dashboardHistory,
        bottomNavigationValue: "homeDialogState"
      });
    }
  };

  handleDashboardBackButtonClick = () => {
    this.handleDashboardActions("BACK");
  };

  handleRedirectToFindHotSpot = async () => {
    const user = this.state.user;
    const prevZip = cache.getItem(cacheItems.PREVIOUS_ZIP_CODE);
    if (prevZip) {
      return `/find-hot-spot/${prevZip}`;
    } else {
      let userDeliveryZip;
      if (user && user.locations) {
        userDeliveryZip = _.find(user.locations, location => {
          return location.isPrimary === 1;
        });
      }

      if (userDeliveryZip) {
        return `/find-hot-spot/${userDeliveryZip.zip}`;
      } else {
        return `/find-hot-spot`;
      }
    }
  };

  handleOpenTutorial = async () => {
    this.setState({ tutorialDialogState: true });
  };

  handleCloseTutorial = async () => {
    this.setState({ tutorialDialogState: false });

    if (!this.state.user.hideTutorial) {
      this.updateUserPreference({ preference: "hideTutorial", value: true });
    }
  };

  handleOpenNewUserDeliveryLocationDialog = async () => {
    this.setState({ newUserDeliveryLocationDialog: true });
  };

  handleCloseNewUserDeliveryLocationDialog = async () => {
    this.setState({ newUserDeliveryLocationDialog: false });
  };

  //USER AND ACCOUNT API CALLS

  loginUser = async (email, password) => {
    try {
      let user = await this.apiPost({
        path: "/user-login",
        body: { email, password },
        auth: false
      });
      cache.setItem(cacheItems.USER_TOKEN, user.token.token);
      cache.setItem(cacheItems.USER_UUID, user.user.uuid);
      this.setState({ user: user.user });
      return user;
    } catch (err) {
      throw err;
    }
  };

  findHotSpot = async zip => {
    let hotspot = await this.apiPost({
      path: "/find-hot-spot",
      body: { zip5: zip },
      auth: true
    });
    return hotspot;
  };

  selectPopUpLocationInstance = async puli => {
    const response = await this.apiPost({
      path: `/users/${cache.getItem(
        cacheItems.USER_UUID
      )}/pop-up-location-instances/${puli.uuid}/select`,
      auth: true
    });

    if (response.previousShoppingCartItems.length > 0) {
      this.setState({
        previousShoppingCartItems: response.previousShoppingCartItems,
        oldShoppingCartDialogState: true,
        appMenuDialogState: false
      });
    }

    cache.setItem(cacheItems.POP_UP_LOCATION_INSTANCE_UUID, puli.uuid);
  };

  giveGift = async ({
    toEmail,
    toUsername,
    message,
    isAnonymous,
    amount,
    campaignCode,
    paymentOptionUuid
  }) => {
    let res = await this.apiPost({
      path: `/users/${cache.getItem(cacheItems.USER_UUID)}/give-gift`,
      body: {
        toEmail,
        toUsername,
        message,
        isAnonymous,
        amount,
        campaignCode,
        paymentOptionUuid
      },
      auth: true
    });

    let user = this.getUserByUuid();

    return { ...user, ...res };
  };

  getUserByUuid = async () => {
    let user = await this.apiGet({
      path: `/users/${cache.getItem(cacheItems.USER_UUID)}`,
      auth: true
    });
    this.setState({ user });
    return user;
  };

  updateUserPreference = async preference => {
    let user = await this.apiPatch({
      path: `/users/${cache.getItem(cacheItems.USER_UUID)}/preferences`,
      auth: true,
      body: preference
    });
    this.setState({ user });
  };

  getPopUpLocationInstanceCheck = async () => {
    let puli = cache.getItem(cacheItems.POP_UP_LOCATION_INSTANCE_UUID);

    if (puli) {
      let check = await this.apiGet({
        path: `/valid-pop-up-location-instance/${puli}`,
        auth: true
      });
      return check;
    } else {
      return true;
    }
  };

  //TODO
  openSuccessSnackbar = text => {
    this.setState({ successSnackbarText: text, successSnackbarState: true });
  };

  openErrorSnackbar = text => {
    this.setState({ errorSnackbarText: text, errorSnackbarState: true });
  };

  closeSuccessSnackbar = () => {
    this.setState({ successSnackbarState: false });
  };

  createPaymentOption = async (accountUuid, token) => {
    await this.apiPost({
      path: `/users/${cache.getItem(
        cacheItems.USER_UUID
      )}/accounts/${accountUuid}/${token}`,
      body: {},
      auth: true
    });

    return await this.getUserByUuid();
  };

  patchUser = async data => {
    let user = await this.apiPatch({
      path: `/users/${cache.getItem(cacheItems.USER_UUID)}`,
      body: { ...data },
      auth: true
    });
    if (user) {
      this.setState({
        successSnackbarState: true,
        successSnackbarText: user.message
      });
    }
  };

  //ATTRIBUTES

  getAttributes = async () => {
    if (this.state.attributes.length === 0) {
      let attributes = await this.apiGet({
        path: `/attributes`,
        auth: true
      });
      this.setState({ attributes });
      return attributes;
    }
    return this.state.attributes;
  };

  //SHOPPING CART

  getCurrentShoppingCart = async () => {
    try {
      let shoppingCart = await this.apiGet({
        path: `/users/${cache.getItem(
          cacheItems.USER_UUID
        )}/pop-up-location-instances/${cache.getItem(
          cacheItems.POP_UP_LOCATION_INSTANCE_UUID
        )}/current-shopping-cart`,
        auth: true
      });
      if (Object.keys(shoppingCart).length > 0) {
        this.setState({ shoppingCart });
        let controlled = _.find(shoppingCart.calculatedInventoryItems, {"isControlled": true})
        if (controlled) {
          this.setState({controlledCartItem : true})
        } else {
          this.setState({controlledCartItem : false})
        }
        return shoppingCart;
      } else {
        return null;
      }
    } catch (err) {
      throw err;
    }
  };

  confirmItemInCart = async item => {
    let shoppingCart = await this.apiPost({
      path: `/users/${cache.getItem(cacheItems.USER_UUID)}/shopping-carts/${
        this.state.shoppingCart.uuid
      }/calculated-inventory-items/${item.uuid}/confirm-for-saving`,
      body: {},
      auth: true
    });
    await this.setState({ shoppingCart });
    return shoppingCart;
  };

  modifyShoppingCart = async (
    item,
    subtractBoolean,
    quantity = 1,
    quick = false
  ) => {
    item.quantityInCartDifference = item.quantityInCartDifference
      ? item.quantityInCartDifference
      : 0;
    item.quantityInCart = item.quantityInCart ? item.quantityInCart : 0;

    if (subtractBoolean) {
      let newQuantity = item.quantityInCart - quantity;
      item.quantityInCart = newQuantity > 0 ? newQuantity : 0;
      if (newQuantity >= 0) {
        item.quantityInCartDifference = item.quantityInCartDifference - quantity;
      }
    } else {
      let newQuantity = item.quantityInCart + quantity;
      if (newQuantity > item.maxAllowedInCart) {
        item.quantityInCart = item.maxAllowedInCart
      } else {
        item.quantityInCart = newQuantity
        item.quantityInCartDifference = item.quantityInCartDifference + quantity;
      }
    }

    let {
      shoppingCart,
      selectedItemViewCategory,
      favorites,
      reorderItems
    } = this.state;

    if (shoppingCart) {
      if (shoppingCart.calculatedInventoryItems.length > 0) {
        let cii = shoppingCart.calculatedInventoryItems.find(
          a => a.uuid === item.uuid
        );
        if (cii) {
          for (let ciiIndex in shoppingCart.calculatedInventoryItems) {
            let cii = shoppingCart.calculatedInventoryItems[ciiIndex];
            if (item.uuid === cii.uuid) {
              // if (item.quantityInCart === 0) {
              // let deletedShoppingCartCiis = shoppingCart.calculatedInventoryItems.splice(ciiIndex, 1)
              // this.setState({ shoppingCart, deletedShoppingCartCiis })
              //   this.setState({ shoppingCart })
              //   break
              // } else {
              shoppingCart.calculatedInventoryItems[ciiIndex] = item;
              this.setState({ shoppingCart });
              break;
              // }
            }
          }
        } else {
          shoppingCart.calculatedInventoryItems.push(item);
          this.setState({ shoppingCart });
        }
      } else {
        shoppingCart.calculatedInventoryItems.push(item);
        this.setState({ shoppingCart });
      }
    }

    if (favorites) {
      for (let ciiIndex in favorites) {
        let cii = favorites[ciiIndex];
        if (item.uuid === cii.uuid) {
          favorites[ciiIndex] = item;
          this.setState({ favorites });
          break;
        }
      }
    }

    if (selectedItemViewCategory) {
      if (selectedItemViewCategory.calculatedInventoryItems) {
        for (let ciiIndex in selectedItemViewCategory.calculatedInventoryItems) {
          let cii = selectedItemViewCategory.calculatedInventoryItems[ciiIndex];
          if (item.uuid === cii.uuid) {
            selectedItemViewCategory.calculatedInventoryItems[ciiIndex] = item;
            this.setState({ selectedItemViewCategory });
            break;
          }
        }
      }
    }

    if (reorderItems) {
      for (let ciiIndex in reorderItems) {
        let cii = reorderItems[ciiIndex];
        if (item.uuid === cii.uuid) {
          reorderItems[ciiIndex] = item;
          this.setState({ reorderItems });
          break;
        }
      }
    }

    return;
  };

  submitShoppingCartChanges = async () => {
    const { shoppingCart } = this.state;

    if (this.state.shoppingCartSubmitting) {
      return null;
    }

    this.setState({ shoppingCartSubmitting: true });

    let changes = false;
    if (
      this.state.shoppingCart &&
      this.state.shoppingCart.calculatedInventoryItems &&
      this.state.shoppingCart.calculatedInventoryItems.length > 0
    ) {
      this.state.shoppingCart.calculatedInventoryItems.map((item, i) => {
        if (
          item.quantityInCartDifference &&
          item.quantityInCartDifference !== 0
        ) {
          changes = true;
        }
        return item
      });
    }

    if (!changes) {
      this.setState({ shoppingCartSubmitting: false });
      return false;
    }

    await Promise.all(
      this.state.shoppingCart.calculatedInventoryItems.map((item, i) => {
        let subtractBoolean;
        let quantity = Math.abs(item.quantityInCartDifference);
        if (item.quantityInCartDifference < 0) {
          subtractBoolean = true;
        }
        if (item.quantityInCartDifference > 0) {
          subtractBoolean = false;
        }
        if (
          !item.quantityInCartDifference ||
          item.quantityInCartDifference === 0
        ) {
          return null;
        }
        return this.apiPatch({
          path: `/users/${cache.getItem(cacheItems.USER_UUID)}/shopping-carts/${
            this.state.shoppingCart.uuid
          }/calculated-inventory-items/${item.uuid}`,
          body: {
            subtract: subtractBoolean,
            quantity: quantity,
            enum: item.enum
          },
          auth: true
        });
      })
    ).then(() => {});

    shoppingCart.calculatedInventoryItems.map(item => {
      this.updateDashboardCards(item);
      return item
    });

    await this.getCurrentShoppingCart();
    this.getUserFavorites();
    this.getUserReorderItems();

    this.setState({ shoppingCartSubmitting: false });

    return true;
  };

  modifyShoppingCartItemNote = async (ciiUuid, customerNote) => {


    let cii = await this.apiPatch({
      path: `/users/${cache.getItem(
        cacheItems.USER_UUID
      )}/shopping-carts/${
        this.state.shoppingCart.uuid
      }/calculated-inventory-items/${ciiUuid}/customer-note`,
      body: {
       customerNote
      },
      auth: true
    });

    await this.getCurrentShoppingCart();

    return cii
  }

  //GROUP CATEGORIES

  getGroupCategories = async popUpLocationInstanceUuid => {
    if (!this.state.groupItemsLoading) {
      this.setState({ groupItemsLoading: true });
      let groupCategories = await this.apiPost({
        path: `/users/${cache.getItem(cacheItems.USER_UUID)}/group-categories`,
        body: {
          popUpLocationInstanceUuid: this.state.shoppingCart
            .popUpLocationInstance.uuid
        },
        auth: true
      });
      this.setState({ groupCategories, groupItemsLoading: false });
    }
  };

  clearGroupCategories = () => {
    this.setState({ groupCategories: [] });
  };

  getMoreGroupCategories = async popUpLocationInstanceUuid => {
    if (!this.state.groupItemsLoading) {
      this.setState({ groupItemsLoading: true });
      let groupCategories = await this.apiPost({
        path: `/users/${cache.getItem(cacheItems.USER_UUID)}/group-categories`,
        body: {
          popUpLocationInstanceUuid: popUpLocationInstanceUuid,
          afterUuid: this.state.groupCategories[
            this.state.groupCategories.length - 1
          ].uuid
        },
        auth: true
      });

      this.setState({
        groupCategories: [...this.state.groupCategories, ...groupCategories],
        groupItemsLoading: false
      });

      return groupCategories;
    }
  };

  getItemsInCategory = async (itemUuid, setState = true) => {
    let selectedItemViewCategory = await this.apiGet({
      path: `/users/${cache.getItem(
        cacheItems.USER_UUID
      )}/pop-up-location-instances/${
        this.state.shoppingCart.popUpLocationInstance.uuid
      }/item-categories/${itemUuid}`,
      auth: true
    });
    if (setState) {
      this.setState({ selectedItemViewCategory });
    }
    return selectedItemViewCategory;
  };

  //FAVORITES

  getUserFavorites = async () => {
    let favorites = await this.apiGet({
      path: `/users/${cache.getItem(
        cacheItems.USER_UUID
      )}/pop-up-location-instances/${cache.getItem(
        cacheItems.POP_UP_LOCATION_INSTANCE_UUID
      )}/favorites`,
      auth: true
    });
    this.setState({ favorites });
    return favorites;
  };

  toggleUpcFavorite = async item => {
    const { shoppingCart } = this.state;
    this.preUpdateFavorite(item);
    //TODO SET GLOBAL STATE WITH CHANGE FIRST
    let favorites = await this.apiPatch({
      path: `/users/${cache.getItem(
        cacheItems.USER_UUID
      )}/pop-up-location-instances/${cache.getItem(
        cacheItems.POP_UP_LOCATION_INSTANCE_UUID
      )}/calculated-inventory-items/${item.uuid}/toggle-favorite`,
      auth: true
    });

    for (let ciiIndex in shoppingCart.calculatedInventoryItems) {
      let cii = shoppingCart.calculatedInventoryItems[ciiIndex];
      if (item.uuid === cii.uuid) {
        shoppingCart.calculatedInventoryItems[
          ciiIndex
        ].isFavorite = !shoppingCart.calculatedInventoryItems[ciiIndex]
          .isFavorite;
        this.setState({ shoppingCart });
      }
    }

    //update favorite in the group category list
    let { groupCategories } = this.state;

    for (let i = 0; i < groupCategories.length; i++) {
      for (let k = 0; k < groupCategories[i].itemCategoryList.length; k++) {
        if (
          groupCategories[i].itemCategoryList[k].inventoryItemCategoryUuid ===
          item.inventoryItemCategoryUuid
        ) {
          let items = await this.getItemsInCategory(
            item.inventoryItemCategoryUuid,
            false
          );
          let favsInItemCat = items.calculatedInventoryItems.filter(
            f => f.isFavorite
          );
          if (favsInItemCat.length > 0) {
            groupCategories[i].itemCategoryList[k].favorited = true;
          } else {
            groupCategories[i].itemCategoryList[k].favorited = false;
          }
          break;
        }
      }
    }

    this.setState({ favorites, groupCategories });
    return favorites;
  };

  async preUpdateFavorite(item) {
    let { favorites, selectedItemViewCategory } = this.state;
    let isFavorite = false;

    if (!favorites) {
      let fetchedFavorites = await this.getUserFavorites();
      favorites = fetchedFavorites;
    }

    isFavorite = favorites.find(i => i.uuid === item.uuid);

    isFavorite = isFavorite ? true : false;

    if (selectedItemViewCategory) {
      for (
        let i = 0;
        i < selectedItemViewCategory.calculatedInventoryItems.length;
        i++
      ) {
        if (
          selectedItemViewCategory.calculatedInventoryItems[i].uuid ===
          item.uuid
        ) {
          selectedItemViewCategory.calculatedInventoryItems[
            i
          ].isFavorite = !isFavorite;

          this.setState({ selectedItemViewCategory });
          break;
        }
      }

      this.setState({ selectedItemViewCategory });
    }
  }

  createFeedback = async ({ message, orderUuid }) => {
    return await this.apiPost({
      path: "/feedback",
      body: { message, orderUuid },
      auth: true
    });
  };

  //REORDER

  getUserReorderItems = async () => {
    let reorderItems = await this.apiGet({
      path: `/users/${cache.getItem(
        cacheItems.USER_UUID
      )}/pop-up-location-instances/${cache.getItem(
        cacheItems.POP_UP_LOCATION_INSTANCE_UUID
      )}/past-order-calculated-inventory-items`,
      auth: true
    });
    this.setState({ reorderItems });
    return reorderItems;
  };

  //ORDERS

  placeOrder = async (
    shoppingCartUuid,
    paymentOptionUuid,
    applyCredit,
    referralCode,
    tipAmount = 0
  ) => {

    let whiteLabelUuid = undefined
    try {
      whiteLabelUuid = cache.getItem(cacheItems.WHITE_LABEL_THEME).uuid
    } catch (error) {
      let newWhiteLabelData = await this.getWhiteLabelData();
      whiteLabelUuid = newWhiteLabelData.uuid
    }

    if (whiteLabelUuid === undefined) {
      let newWhiteLabelData = await this.getWhiteLabelData();
      whiteLabelUuid = newWhiteLabelData.uuid
    }

    let order = await this.apiPost({
      path: `/users/${cache.getItem(
        cacheItems.USER_UUID
      )}/shopping-carts/${shoppingCartUuid}/make-order?tipAmount=${tipAmount}`,
      body: {
        paymentOptionUuid,
        isSnap: !paymentOptionUuid ? true : false,
        referralCode,
        applyCredit,
        whiteLabelUuid
      },
      auth: true
    });
    return order;
  };

  cancelOrder = async orderUuid => {
    try {
      let order = await this.apiPost({
        path: `/users/${cache.getItem(
          cacheItems.USER_UUID
        )}/orders/${orderUuid}/cancel-order`,
        auth: true
      });
      return order;
    } catch (error) {
      // console.log(error)
      throw error
    }
    
  };
  getUserOrders = async () => {
    let orders = await this.apiGet({
      path: `/users/${cache.getItem(cacheItems.USER_UUID)}/orders`,
      auth: true
    });
    this.setState({ orders });
  };

  //SEARCH

  getSearchResults = async text => {
    this.setState({
      searchResultPromiseCount: this.state.searchResultPromiseCount + 1
    });

    let searchResults = await this.apiPost({
      path: `/users/${cache.getItem(
        cacheItems.USER_UUID
      )}/pop-up-location-instances/${
        this.state.shoppingCart.popUpLocationInstance.uuid
      }/search/${text ? text : this.state.searchBarTextValue}`,
      auth: true
    });

    this.setState({
      searchResultPromiseCount: this.state.searchResultPromiseCount - 1
    });

    if (
      this.state.searchBarTextValue.length > 0 &&
      this.state.searchResultPromiseCount === 0
    ) {
      this.setState({ searchResults, scrollPositionSet: false });
    }
  };

  getMoreSearchResults = async text => {
    if (!this.state.searchItemsLoading) {
      this.setState({ searchItemsLoading: true });
      let searchResults = await this.apiPost({
        path: `/users/${cache.getItem(
          cacheItems.USER_UUID
        )}/pop-up-location-instances/${
          this.state.shoppingCart.popUpLocationInstance.uuid
        }/search/${text ? text : this.state.searchBarTextValue}`,
        body: {
          afterUuid: this.state.searchResults[
            this.state.searchResults.length - 1
          ].uuid
        },
        auth: true
      });

      this.setState({
        searchResults: [...this.state.searchResults, ...searchResults],
        searchItemsLoading: false
      });
      return searchResults;
    }
  };

  // FORGOT PASSWORD
  initiateForgotPassword = async email => {
    let response = await this.apiPost({
      path: `/initiate-forgot-password/${email}`,
      auth: false
    });
    return response;
  };

  submitPasswordForReset = async (password, token) => {
    let response = await this.apiPost({
      path: `/reset-password`,
      body: {
        token,
        password
      },
      auth: false
    });
    return response;
  };

  //LOCATIONS

  createUserLocation = async location => {
    let body = { locationData: location };

    if (this.state.shoppingCart) {
      let popupLocation = this.state.shoppingCart.popUpLocationInstance
        .popupLocation;
      body.popupLocation = popupLocation;
    }

    let response = await this.apiPost({
      path: `/users/${cache.getItem(cacheItems.USER_UUID)}/locations`,
      body: body,
      auth: true
    });

    return response;
  };

  updateDeliveryLocation = async location => {
    let { shoppingCart } = this.state;
    let body = { locationData: location };

    let response = await this.apiPost({
      path: `/users/${cache.getItem(cacheItems.USER_UUID)}/shoppingCarts/${
        shoppingCart.uuid
      }/userLocations/${location.uuid}/update`,
      body: body,
      auth: true
    });

    await this.getCurrentShoppingCart();

    return response;
  };

  //AXIOS API HELPERS
  /*eslint no-restricted-globals: [0]*/
  apiGet = ({ path, headers = {}, auth = false }) => {
    if (auth) {
      const userToken = cache.getItem(cacheItems.USER_TOKEN);
      headers["Authorization"] = `Bearer ${userToken}`;
    }
    headers["x-ff-label"] = `${location.host}`;

    return axios({
      method: "GET",
      url: `${config.gateway.baseUrl}${path}`,
      headers
    })
      .then(res => {
        // console.log('Axios GET')
        return res.data;
      })
      .catch(err => {
        // console.log('Axios GET Error', err.response)
        this.errorHandler(err);
        throw err;
      });
  };

  apiPost = ({ path, headers = {}, body, auth = false }) => {
    if (auth) {
      const userToken = cache.getItem(cacheItems.USER_TOKEN);
      headers["Authorization"] = `Bearer ${userToken}`;
    }
    headers["x-ff-label"] = `${location.host}`;

    return axios({
      method: "POST",
      url: `${config.gateway.baseUrl}${path}`,
      data: body,
      headers
    })
      .then(res => {
        // console.log('Axios POST')
        return res.data;
      })
      .catch(err => {
        // console.log('Axios POST Error', err.response)
        this.errorHandler(err);
        throw err.response;
      });
  };

  apiPatch = ({ path, headers = {}, body, auth = false }) => {
    if (auth) {
      const userToken = cache.getItem(cacheItems.USER_TOKEN);
      headers["Authorization"] = `Bearer ${userToken}`;
    }
    headers["x-ff-label"] = `${location.host}`;

    return axios({
      method: "PATCH",
      url: `${config.gateway.baseUrl}${path}`,
      data: body,
      headers
    })
      .then(res => {
        // console.log('Axios PATCH', res)
        return res.data;
      })
      .catch(err => {
        // console.log('Axios PATCH Error', err.response)
        this.errorHandler(err);
        throw err.response;
      });
  };

  errorHandler = async err => {
    console.log(err.response);
    if (
      err.response === undefined ||
      err.response.status === undefined ||
      err.response.status >= 500
    ) {
      this.setState({
        errorNeedsRedirect: false,
        errorSnackbarState: true,
        errorSnackbarText: "Internal Server Error"
      });
      return;
    }
    if (err.response.status === 400) {
      this.setState({
        errorSnackbarState: true,
        errorSnackbarText: err.response.data.error
      });
      this.setAllDialogsToFalse();
      return;
    }
    if (err.response.status === 401) {
      let path = this.props.location.pathname;
      if (path === "/password-reset/" || path === "/login" || path === "/") {
        return;
      }

      this.setState({
        errorNeedsRedirect: true,
        errorRedirectRoute: "/login",
        errorSnackbarState: true,
        errorSnackbarText: err.response.data.error
      });
      this.setAllDialogsToFalse();
      return;
    }
    if (err.response.status === 404) {
      this.setState({
        errorNeedsRedirect: true,
        errorRedirectRoute: "/find-hot-spot",
        errorSnackbarState: true,
        errorSnackbarText: err.response.data.error
      });
      this.setAllDialogsToFalse();
      return;
    }
    if (err.response.status === 410) {
      let redirect = await this.handleRedirectToFindHotSpot();
      this.setState({
        errorNeedsRedirect: true,
        errorRedirectRoute: redirect,
        successSnackbarState: true,
        successSnackbarText: err.response.data.error
      });
      this.setAllDialogsToFalse();
      return;
    }
  };

  clearErrorRedirect = () => {
    this.setState({ errorNeedsRedirect: false, errorRedirectRoute: null });
  };

  logout = () => {
    cache.clearAll();
    // Do full page refresh so that the SDK cache is cleared.
    window.location.href = "/login";
  };

  render() {
    const global = {
      data: this.state,
      storeGroupCategories: this.storeGroupCategories,
      appendGroupCategories: this.appendGroupCategories,
      groupCategories: this.groupCategories,
      getGroupCategories: this.getGroupCategories,
      getMoreGroupCategories: this.getMoreGroupCategories,
      getItemsInCategory: this.getItemsInCategory,
      loginUser: this.loginUser,
      patchUser: this.patchUser,
      getUserFavorites: this.getUserFavorites,
      toggleUpcFavorite: this.toggleUpcFavorite,
      getCurrentShoppingCart: this.getCurrentShoppingCart,
      modifyShoppingCart: this.modifyShoppingCart,
      setShoppingCart: this.setShoppingCart,
      placeOrder: this.placeOrder,
      getUserOrders: this.getUserOrders,
      getSearchResults: this.getSearchResults,
      confirmItemInCart: this.confirmItemInCart,
      getMoreSearchResults: this.getMoreSearchResults,
      setGlobalState: this.setGlobalState,
      getAttributes: this.getAttributes,
      apiGet: this.apiGet,
      apiPost: this.apiPost,
      apiPatch: this.apiPatch,
      getUserByUuid: this.getUserByUuid,
      createPaymentOption: this.createPaymentOption,
      postFeedback: this.createFeedback,
      openSuccessSnackbar: this.openSuccessSnackbar,
      closeSuccessSnackbar: this.closeSuccessSnackbar,
      cancelOrder: this.cancelOrder,
      initiateForgotPassword: this.initiateForgotPassword,
      submitPasswordForReset: this.submitPasswordForReset,
      clearGroupCategories: this.clearGroupCategories,
      getUserReorderItems: this.getUserReorderItems,
      getPopUpLocationInstanceCheck: this.getPopUpLocationInstanceCheck,
      stateHardReset: this.stateHardReset,
      findHotSpot: this.findHotSpot,
      selectPopUpLocationInstance: this.selectPopUpLocationInstance,
      checkShoppingTimeLeft: this.checkShoppingTimeLeft,
      submitShoppingCartChanges: this.submitShoppingCartChanges,
      openErrorSnackbar: this.openErrorSnackbar,
      handleDashboardActions: this.handleDashboardActions,
      handleDashboardBackButtonClick: this.handleDashboardBackButtonClick,
      createUserLocation: this.createUserLocation,
      updateDeliveryLocation: this.updateDeliveryLocation,
      giveGift: this.giveGift,
      handleRedirectToFindHotSpot: this.handleRedirectToFindHotSpot,
      handleOpenTutorial: this.handleOpenTutorial,
      handleCloseTutorial: this.handleCloseTutorial,
      handleOpenNewUserDeliveryLocationDialog: this
        .handleOpenNewUserDeliveryLocationDialog,
      handleCloseNewUserDeliveryLocationDialog: this
        .handleCloseNewUserDeliveryLocationDialog,
      logout: this.logout,
      modifyShoppingCartItemNote: this.modifyShoppingCartItemNote,
    };

    // console.log('global state', this.state)

    if (!this.state.whiteLabelData) {
      return null;
    }

    // if (isBrowser && !this.state.deviceCheck) {
    //   console.log('Global BROWSER')
    //   this.setState({deviceCheck: true})
    //   return <Redirect to='/'/>
    // }

    if (this.state.errorSnackbarState) {
      setTimeout(() => {
        this.setState({ errorSnackbarState: false });
      }, 5000);
    }

    if (this.state.successSnackbarState) {
      setTimeout(() => {
        this.setState({
          successSnackbarState: false,
          popUpLocationInstanceDialogCallout: -350,
          popUpLocationInstanceDialogState: false,
          bottomNavigationValue: "homeDialogState"
        });
      }, 5000);
    }

    if (
      this.state.errorNeedsRedirect &&
      this.state.errorRedirectRoute &&
      !this.state.errorSnackbarState &&
      !this.state.successSnackbarState
    ) {
      this.clearErrorRedirect();
      this.stateHardReset();
      return <Redirect to={this.state.errorRedirectRoute} />;
    }

    return (
      <GlobalContext.Provider
        value={{
          global
        }}
      >
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          style={{ zIndex: 90004 }}
          open={this.state.errorSnackbarState}
          onClick={() =>
            this.setState({ errorSnackbarState: false, errorSnackbarText: "" })
          }
          onClose={() =>
            this.setState({ errorSnackbarState: false, errorSnackbarText: "" })
          }
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          message={
            <div
              // className={s.snackbarText}
              id="message-id"
              style={{
                display: "flex",
                minHeight: "70px",
                justifyItems: "center",
                alignItems: "center"
              }}
            >
              <CancelIcon
                style={{
                  color: this.props.theme.palette.error.main
                }}
              />
              <div style={{ paddingLeft: 10 }}>
                {this.state.errorSnackbarText}
              </div>
            </div>
          }
        />
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          style={{ zIndex: 90004 }}
          open={this.state.successSnackbarState}
          // open={true}
          onClick={() =>
            this.setState({
              successSnackbarState: false,
              successSnackbarText: ""
            })
          }
          onClose={() =>
            this.setState({
              successSnackbarState: false,
              successSnackbarText: ""
            })
          }
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          message={
            <div
              // className={s.snackbarText}
              id="message-id"
              style={{
                display: "flex",
                minHeight: "70px",
                justifyItems: "center",
                alignItems: "center"
              }}
            >
              <CheckBox
                style={{
                  color: this.props.theme.palette.secondary.main
                }}
              />
              <div style={{ paddingLeft: 10 }}>
                {this.state.successSnackbarText}
              </div>
            </div>
          }
        />
        <Helmet>
          <title>{label.title}</title>
          <link rel="shortcut icon" href={label.logoUrl} />
        </Helmet>

        {isIOS ? (
          <div
            style={{
              height: 14,
              backgroundColor: this.props.theme.palette.primary.main,
              position: "fixed",
              top: 0,
              width: "-webkit-fill-available",
              zIndex: 90000
            }}
          />
        ) : null}

        {this.props.children}
      </GlobalContext.Provider>
    );
  }
}

export default withTheme()(withRouter(GlobalProvider));

function isEquivalent(a, b) {
  // Create arrays of property names
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);

  // If number of properties is different,
  // objects are not equivalent
  // eslint-disable-next-line eqeqeq
  if (aProps.length != bProps.length) {
    return false;
  }

  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i];

    // If values of same property are not equal,
    // objects are not equivalent
    if (a[propName] !== b[propName]) {
      return false;
    }
  }

  // If we made it this far, objects
  // are considered equivalent
  return true;
}
